// This file should only contain action type constants.

// export const SET_FOO = 'SET_FOO';
export const SET_WIDGET_STATE = 'SET_WIDGET_STATE';
export const LOAD_PRICE = 'LOAD_PRICE';
export const LOAD_OEM_CALCULATOR_CONFIG = 'LOAD_OEM_CALCULATOR_CONFIG';

export const UPDATE_DOWN_PAYMENT = 'UPDATE_DOWN_PAYMENT';
export const UPDATE_APR = 'UPDATE_APR';
export const UPDATE_SELECTED_APR_TERM = 'UPDATE_SELECTED_APR_TERM';
export const RESET_CALCULATOR = 'RESET_CALCULATOR';



// WEBPACK FOOTER //
// ./src/actions/types.js